/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: 工具包
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-05-10 19:41:16
 * @LastEditTime: 2023-04-27 15:34:56
 * @FilePath: /client-h5-v2/src/common-ts/utils.ts
 */

import BScroll from 'better-scroll'
import store from '@/store/index'
import { encodeMappingDev, encodeMapping } from '@/common-ts/emojMapping'

/**
 *
 * @description: 存储指定cookie
 * @param {string} key cookie的key
 * @param {string | number | boolean} val cookie的值
 * @return {void} 无返回值
 *
 */
export const setCookie = (key:string, val:string | number | boolean, expires?:any) => {
  const d = new Date()
  // 所有设置cookie的都设置默认30天的有效期,
  if (expires) {
    d.setDate(d.getDate() + expires)
  } else {
    d.setDate(d.getDate() + 30)
  }
  document.cookie = key + '=' + val + ';path=/;expires=' + d
}

/**
 *
 * @description: 获取指定key的cookie值
 * @param {string} key cookie的key
 * @return {any} value
 *
 */
export const getCookie = (key:string): any => {
  const cookie = document.cookie
  const arr = cookie.split('; ')
  for (const value of arr) {
    const newArr = value.split('=')
    if (key === newArr[0]) {
      return newArr[1]
    }
  }
}

/**
 *
 * @description: 删除cookie
 * @param {string} key cookie的key
 * @return {any} value
 *
 */
export const deleteCookie = (name: string) => {
  const exp = new Date()
  exp.setTime(exp.getTime() + (-1 * 24 * 60 * 60 * 1000))
  const cval = getCookie(name)
  document.cookie = name + '=' + cval + ';path=/;expires=' + exp.toString()
}


/**
 *
 * @description: 获取当前时间是（早晨、中午、下午、晚上）
 * @param {void} 无参数
 * @return {string} zaochen zhongwu xiawu wanshang
 *
 */
export const getTimeState = ():string => {
  // 获取当前时间
  const timeNow = new Date()
  // 获取当前小时
  const hours = timeNow.getHours()
  // 设置默认文字
  let state = ''
  // 判断当前时间段
  if (hours >= 0 && hours <= 10) {
    state = 'zaochen'
  } else if (hours > 10 && hours <= 14) {
    state = 'zhongwu'
  } else if (hours > 14 && hours <= 18) {
    state = 'xiawu'
  } else if (hours > 18 && hours <= 24) {
    state = 'wanshang'
  }
  return state
}

/**
 *
 * @description 设置浏览器标签页icon
 * @param {void} 无参数
 * @return {string} zaochen zhongwu xiawu wanshang
 *
 */
export const setBrowser = (browserLabel: {icon: string, title: string}) => {
  // 设置浏览器标签页favicon
  const link: any = document.querySelector('link[rel*=\'icon\']') || document.createElement('link')
  link.type = 'image/x-icon'
  link.rel = 'shortcut icon'
  link.href = browserLabel.icon
  document.getElementsByTagName('head')[0].appendChild(link)
  // 设置浏览器标签页titleSs
  document.getElementsByTagName('title')[0].innerHTML = browserLabel.title
}

/**
 *
 * @description 监听dom变化（属性、添加、删除等）❌ 当下弃用了
 * @param {string} id dom id 属性
 * @return {void} 无返回值
 *
 */
export const DomChangeListener = (id: string):void => {
  let ovserverTimer:any
  // Firefox和Chrome早期版本中带有前缀
  const MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver
  // 选择目标节点
  const target = document.getElementById(id) as HTMLElement
  // 创建观察者对象
  const observer = new MutationObserver(function () {
    clearTimeout(ovserverTimer)
    ovserverTimer = setTimeout(() => {
      betterScrollUpdated(store.getters['dialog/bs'])
    }, 300)
  })
  // 配置观察选项:
  const config = {
    childList: true,
    subtree: true,
    attributes: true
  }
  // 传入目标节点和观察选项
  observer.observe(target, config)
}

/**
 *
 * @description 注册滚动条
 * @param {string} id dom id 属性
 * @return {any} bs
 *
 */
let bs: any
export const registerBetterScroll = (id: string): any => {
  // 获取dom注册滚动
  const element = document.querySelector('#' + id)
  bs = new BScroll(element as any, {
    preventDefaultException: {
      // 表示下面标签的默认行为不会被阻止
      tagName: /^(SPAN|DIV|P|UL|LI|STRONG|B|I|H1|H2|H3|H4|H5|H6|A|DL|DT|DD|IMG|BUTTON|INPUT|RADIO|SELECT|TEXTAREA|CHECKBOX)$/
    },
    preventDefault: false,
    scrollbar: {
      fade: true,
      interactive: true,
      scrollbarTrackClickable: true
    },
    observeDOM: true, // 监听dom变化执行refresh
    observeImage: true, // 监听图片变化执行refresh
    mouseWheel: true, // 鼠标滚轮是否打开
    disableMouse: false, // 是否禁止鼠标
    disableTouch: false,
    click: store.getters['global/device'] !== 'mobile_pad' || false,
    bounce: false // 当滚动超过边缘的时候会有一小段回弹动画。设置为 true 则开启动画
  })
  // 等待刷新better scroll，解决高度计算错误的问题
  setTimeout(() => {
    // bs.refresh()
    betterScrollUpdated(bs)
  }, 20)

  return bs
}

/**
 *
 * @description 刷新滚动条
 * @param {any} betterScroll dom id 属性
 * @return {string} zaochen zhongwu xiawu wanshang
 *
 */
export const betterScrollUpdated = (betterScroll: any) => {
  betterScroll.refresh()
}

/**
 *
 * @description 置底滚动条
 * @param {string} betterScroll dom id 属性
 * @return {string} zaochen zhongwu xiawu wanshang
 *
 */
export const betterScrollToBottom = (betterScroll: any) => {
  // setTimeout(() => {
  //   const length = store.getters['dialog/talklist'].length
  //   console.log(length)
  //   console.log(document.querySelectorAll('.chatbot-box'))
  //   // 所有bot回复的消息数组减去当前这次回来的消息数组长度，从而确定clientItem也就是滚动条滚动到哪个dom上
  //   const clientItem = document.querySelectorAll('.chatbot-box')[document.querySelectorAll('.chatbot-box').length - length]
  //   betterScroll.scrollToElement(clientItem, 300, 0, -53, 'linear')
  // }, 1000)


  betterScroll.scrollTo(0, betterScroll.maxScrollY, 1000)
}

/**
 *
 * @description 滚动到指定dom
 * @param {string} id dom id 属性
 * @return {string} void
 *
 */
export const betterScrollToElement = (betterScroll: any) => {
  setTimeout(() => {
    const length = store.getters['dialog/botMsgList'].length
    // 所有bot回复的消息数组减去当前这次回来的消息数组长度，从而确定clientItem也就是滚动条滚动到哪个dom上
    const clientItem = document.querySelectorAll('.chatbot-box')[document.querySelectorAll('.chatbot-box').length - length]
    betterScroll.scrollToElement(clientItem, 500, 0, -80, 'linear')
  }, 200)
}

/**
* @description 验证两个数组内数据是否一致
*/
export const areArraysEqual = (array1:any, array2:any) => {
  // eslint-disable-next-line no-array-constructor
  const temp = []
  if ((!array1[0]) || (!array2[0])) { // If either is not an array
    return false
  }
  if (array1.length !== array2.length) {
    return false
  }
  // Put all the elements from array1 into a "tagged" array
  for (const element of array1) {
    const key:any = (typeof element) + '~' + element
    // Use "typeof" so a number 1 isn't equal to a string "1".
    if (temp[key]) {
      temp[key]++
    } else {
      temp[key] = 1
    }
    // temp[key] = # of occurrences of the value (so an element could appear multiple times)
  }
  // Go through array2 - if same tag missing in "tagged" array, not equal
  for (const element of array2) {
    const key:any = (typeof element) + '~' + element
    if (temp[key]) {
      if (temp[key] === 0) {
        return false
      } else {
        temp[key]--
      }
      // Subtract to keep track of # of appearances in array2
    } else {
      // Key didn't appear in array1, arrays are not equal.
      return false
    }
  }
  // If we get to this point, then every generated key in array1 showed up the exact same
  // number of times in array2, so the arrays are equal.
  return true
}

/**
 *
 * @description 动态加载js文件
 * @param {string} path 文件路径
 * @return {void} 无返回值
 *
 */
export const loadScript = (path: string, callback:{ (): void }) => {
  const script:HTMLScriptElement = document.createElement('script')
  script.type = 'text/javascript'
  script.src = path
  script.addEventListener('load', function () {
    callback()
  }, false)
  document.body.appendChild(script)
}

/**
 *
 * @description 动态加载css文件
 * @param {string} path 文件路径
 * @return {void} 无返回值
 *
 */
export const loadStyle = (path: string) => {
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.type = 'text/css'
  link.href = path
  document.head.appendChild(link)
}

/**
 *
 * @description 个位数补0
 * @return {string} 格式化后的时间字符串
 *
 */
const zeroize = (num:number) => {
  return num < 10 ? '0' + num : num
}

/**
 *
 * @description 获取当前时间 年-月-日 时:分:秒
 * @return {string} 日期时间字符串
 */
export const getCurrentTime = () => {
  const date = new Date()
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()
  return [year, month, day].map(zeroize).join('-') + ' ' + [hour, minute, second].map(zeroize).join(':')
}

/**
 * @description 获取当前日期 年-月-日
 */
export const getCurrentDate = () => {
  const date = new Date()
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  return [year, month, day].map(zeroize).join('-')
}

/**
 * @description 获取当前时间 时:分:秒
 * @return {string} 时分秒字符串
 */
export const getCurrentTimeHHMMSS = () => {
  const date = new Date()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()
  return [hour, minute, second].map(zeroize).join(':')
}

/**
 *
 * @description 获取12小时制的时:分:秒
 * @return {string} 时:分:秒 字符串
 */
export const getCurrentTimeHHMMSS12 = () => {
  const date = new Date()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()
  const ampm = hour >= 12 ? 'PM' : 'AM'
  return [hour, minute, second].map(zeroize).join(':') + ' ' + ampm
}


/**
 *
 * @description 判断指定时间是否在指定的工作时间内
 * @param {string} workTime 工作时间 eg: '09:00,18:00'
 * @param {string} time 指定时间 eg: '09:00'
 * @returns {boolean} true/false 是/否
 *
 */
export const isWorkTime = (workTime: string, time: string) => {
  let workTimeArr = workTime.split(',')
  const timeArr = time.split(':')
  const hour = Number(timeArr[0])
  const minute = Number(timeArr[1])
  workTimeArr = workTime.split(',')
  const workTimeStart = workTimeArr[0].split(':')
  const workTimeEnd = workTimeArr[1].split(':')
  const workTimeStartHour = Number(workTimeStart[0])
  const workTimeStartMinute = Number(workTimeStart[1])
  const workTimeEndHour = Number(workTimeEnd[0])
  const workTimeEndMinute = Number(workTimeEnd[1])
  if (hour >= workTimeStartHour && hour < workTimeEndHour) {
    return true
  } else if (hour === workTimeStartHour && minute >= workTimeStartMinute) {
    return true
  } else if (hour === workTimeEndHour && minute < workTimeEndMinute) {
    return true
  } else {
    return false
  }
}

/**
 *
 * @description 判断某天是否为工作日
 * @param {string} workDay 指定工作日 eg: '1,2,3,4,5' 代表周一到周五
 * @param {string} day 指定年-月-日 eg: '2022-07-16'
 * @returns {boolean} true/false 是/否
 *
 */
export const isWorkDay = (workDay: string, day: string) => {
  const workDayArr = workDay.split(',')
  const dayArr = day.split('-')
  const year = Number(dayArr[0])
  const month = Number(dayArr[1])
  const days = Number(dayArr[2])
  const date = new Date(year, month - 1, days)
  const week = date.getDay()
  if (workDayArr.indexOf(week.toString()) !== -1) {
    return true
  } else {
    return false
  }
}

/**
 * 获取唯一id
 */
export const getUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

// 将字符串中每个含有data-emoji的属性的img标签替换成[表情]
export const replaceImgToEmoj = (str: string) => {
  const reg = /<img.*?data-emoji="\[(.*?)\]".*?>/g
  return str.replace(reg, '[$1]')
}

/**
 * 将字符串中包含[微笑]格式的表情替换成img标签
 */
export const replaceEmojToImg = (str: string) => {
  // 根据项目名称获取对应的表情icon路径
  const emojiBasePath = `/${window.botV2GlobalProperties.BASE_PATH}/img/${getProjectName()}/emoji/`
  // 根据项目名称获取对应的表情映射列表
  const emojiMappingList = getProjectName() === 'zhilian' ? encodeMappingDev : encodeMapping
  const reg = /\[(.*?)\]/g
  return str.replace(reg, (match, p1) => {
    const item = emojiMappingList.find((item) => item.cn === p1)
    if (item) {
      return `<img data-emoji=[${item.cn}] class="emoji" src="${emojiBasePath}${item.en}.png" alt="${item.cn}">`
    }
    return match
  })
}
/**
 * 将字符串中包含[url]格式的替换成a标签
 */
export const replaceUrlToAElement = (str: string) => {
  const regexp = /(http?:\/\/|https?:\/\/|www\.)[a-zA-Z_0-9\-@]+(\.\w[a-zA-Z_0-9\-:]+)+(\/[\(\)~#&\-=?\+\%/\.\w]+)?/g
  return str.replace(regexp, (url:string) => {
    return '<a href=\'' + url + '\' target=\'_blank\'>' + url + '</a>'
  })
}

/**
 * @description 设置placeholder
 */
export const setPlaceholder = (content: string) => {
  const style = document.createElement('style') // 创建<style></style>标签
  const text = document.createTextNode(`div[contenteditable]:empty:before {
    content: "${content}";
    font-size: 14px;
    color: var(--kd-send-tips-text-color);
  }`) // 添加伪类样式
  style.appendChild(text) // 把伪类样式添加样式表
  document.body.appendChild(style)
}

/**
 *
 * @description 动态创建小乐项目mate标签
 * @param {string} path 文件路径
 * @return {void} 无返回值
 *
 */
export const createXiaoleMate = (projectName:string) => {
  if (projectName === 'xiaole') {
    const metaDescription = document.createElement('meta')
    metaDescription.name = 'description'
    metaDescription.content = '联想在线客服，全天24小时在线，全年365天无休，随时随地为您解决电脑问题。采用第三代智能科技，结合大数据及深度学习技术，为您带来前所未有的服务体验。'
    document.head.appendChild(metaDescription)
    const metaKeywords = document.createElement('meta')
    metaKeywords.name = 'keywords'
    metaKeywords.content = '联想在线客服,在线客服,智能客服,联想客服,联想智能客服,联想小乐,智能机器人'
    document.head.appendChild(metaKeywords)
  }
}

/**
 * @description 多次点击触发一次
 */
let throttleTimer:any = null
export const throttle = (fn:any, delay:number) => {
  return (function () {
    clearTimeout(throttleTimer)
    throttleTimer = setTimeout(() => {
      fn()
      clearTimeout(throttleTimer)
    }, delay)
  })()
}
/**
 * @description 滚动条滚动到指定位置
 * @param {*} el  滚动的元素
 * @param {*} block 定义垂直方向的对齐， "start", "center", "end", 或 "nearest"之一。默认为 "start"
 * @param {*} inline // 定义水平方向的对齐， "start", "center", "end", 或 "nearest"之一。默认为 "nearest"
 * @param {*} behavior 定义动画过渡效果， "auto", "instant, 或" "smooth" 之一。默认为 "auto"
 * @returns
 */
export const scrollIntoViewFn = (el:any, block?:any, inline?:any, behavior?:any) => {
  el.scrollIntoView({
    block: block || 'start',
    inline: inline || 'nearest',
    behavior: behavior || 'smooth'
  })
}

/**
 * @description 字符串转小写
 * @param {*} str  字符串
 */
export const toLowerCase = (str: string) => {
  return str.toLowerCase()
}

/**
 * @description 它接受一个参数（字节数），并根据其大小返回格式化后的字符串
 * @param bytes 字节
 * @returns xxx kb/xxx mb
 * const fileSizeInBytes = 1234567; // 1.2 MB
 * const formattedFileSize = formatFileSize(fileSizeInBytes);
 * console.log(formattedFileSize); // "1.2 MB"
 */
export const formatFileSize = (bytes: string) => {
  if (Number(bytes) < 500000) {
    return (Number(bytes) / 1024).toFixed(0) + ' KB'
  } else {
    return (Number(bytes) / (1024 * 1024)).toFixed(1) + ' MB'
  }
}

/**
 * 返回数组中包含传入参数的元素
 */
const acceptArr = ['.zip', '.rar', '.doc', '.docx', '.xls', '.xlsx', '.pdf', '.mp3', '.wav', '.wma', '.flac', '.midi', '.ra', '.ape', '.aac', '.cda', '.mov', '.avi', '.wma', '.rmvb', '.rm', '.flash', '.mp4', '.mid', '.3gp', '.txt', '.mpeg', '.asf', '.wmv', '.flv', '.f4v', '.msg']
export const isInclude = (str: string) => {
  let isInclude:any = false
  acceptArr.forEach((item) => {
    if (str.includes(item)) {
      isInclude = item
    }
  })
  return isInclude
}

/**
 * 获取项目名称
 */
export const getProjectName = () => {
  return store.getters['global/projectName']
}
